import { useEffect, useRef } from 'react'
import styles from './portal.module.css'
import { Header } from '../header'
import { MeshAppBridge } from '../../meshAppBridge/bridge'

type Props = {
  bridge: MeshAppBridge
  loadSiteName: string
}

const Portal = ({ bridge, loadSiteName }: Props) => {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  useEffect(() => {
    const iframe = iframeRef.current
    if (!iframe) return
    bridge.setAppHost(iframe)
  }, [bridge])

  return (
    <div className={styles.portalContainer}>
      <Header />
      <iframe
        className={styles.portal}
        src={loadSiteName}
        ref={iframeRef}
        title="Site Content"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        loading="lazy"
        allow="clipboard-read; clipboard-write"
      />
    </div>
  )
}

export default Portal
